import React from "react";
import PropTypes from "prop-types";
import {
  Typography,
  createTheme,
  ThemeProvider,
  Box
} from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import * as TextVariables from "../../../assets/Variables/TextVariables.js";
import Colors from "../../../assets/Variables/ColorsVariables.js";

const DateSelector = ({ title, value, handleChange, variant = "default" }) => {

  //Statements Styles
  const statementsTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontWeight: "400",
              fontSize: "12px",
              fontFamily: "Plus Jakarta Sans",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: '8px',
              height: "40px",
              width: "131px",
            },
            "& .MuiInputBase-input::placeholder": {
              textTransform: "lowercase",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${Colors.Secondary_700}`,
            },
            "& .MuiIconButton-root": {
              padding: "8px",
            },
            "& .MuiSvgIcon-root": {
              height: "16px",
              width: "16px"
            },
          },
        },
      },
    },
  });

  //Default Styles
  const defaultTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontWeight: "400",
              fontSize: "10px",
              fontFamily: "Plus Jakarta Sans",
              textTransform: "lowercase",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: '8px',
              height: "38px",
              width: "131px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${Colors.Secondary_400}`
            },
            "& .MuiInputBase-input::placeholder": {
              textTransform: "lowercase",
            },
            "& .MuiIconButton-root": {
              padding: "10px",
              fontSize: "5px"
            },
            "& .MuiSvgIcon-root": {
              height: "16px",
              width: "16px"
            },
          },
        },
      },
    },
  });

  // Label Statements Styles
  const statementsLabelStyle = {
    marginBottom: "4px",
    fontFamily: "Plus Jakarta Sans, sans-serif",
    fontWeight: 400,
    fontSize: "11px",
    lineHeight: "140%",
    color: Colors.Secondary_700,
  };

  const defaultLabelStyle = {
    marginBottom: "5px",
    fontFamily: TextVariables.Body_4
  };

  const currentTheme = variant === "statements" ? statementsTheme : defaultTheme;
  const currentLabelStyle = variant === "statements" ? statementsLabelStyle : defaultLabelStyle;

  return (
    <ThemeProvider theme={currentTheme}>
      <Box>
        <Typography sx={currentLabelStyle}>
          {title}
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={value}
            onChange={handleChange}
            InputProps={{
              sx: {
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              },
            }}
          />
        </LocalizationProvider>
      </Box>
    </ThemeProvider>
  );
};

DateSelector.propTypes = {
  title: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  variant: PropTypes.string,
};

export default DateSelector;